module.exports = __webpack_public_path__ + "static/media/ic_mentored_green.bd986c09.svg";